// extracted by mini-css-extract-plugin
export default {"commentInputAvatar":"CommentInput_commentInputAvatar__z8vA4","commentInput":"CommentInput_commentInput__cgRtc","controlError":"CommentInput_controlError__FfyN8"};